import { notification } from "antd";
import { DcOffLineHost } from "../../config";
import { LIMIT_REPONSE_FAILURE, LIMIT_REPONSE_REQUEST, LIMIT_REPONSE_SUCCESS } from "../Types";



export const fermerReponsesFormulaire = (formId, action) => {
  return async (dispatch) => {
    dispatch({ type: LIMIT_REPONSE_REQUEST });

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Token non trouvé. Veuillez vous reconnecter.");
      }

      const response = await fetch(`${DcOffLineHost}api/forms/toggleForm/${formId}?action=${action}`, {
        method: "GET", 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Erreur lors de la fermeture du formulaire");
      }

      dispatch({ type: LIMIT_REPONSE_SUCCESS, payload: data });

      notification.success({
        message: data?.message || "Réponses fermées avec succès",
        duration: 5,
      });

      return data;
    } catch (error) {
      dispatch({ type: LIMIT_REPONSE_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Erreur lors de la fermeture du formulaire",
        duration: 5,
      });
    }
  };
};
